import { css } from "@emotion/css";

import { Text } from "../../../../foundations/typography/Text";

import { getPosition } from "./utils";
import { Config } from "../types";
interface Props {
  config: Config;
  score: number;
}

export function Badge(props: Props) {
  const { config, score } = props;
  const styles = getStyles(
    getPosition(score, config.minRange, config.maxRange)
  );

  return (
    <span className={styles.badge}>
      <Text
        color="text-inverse"
        style="global/metric-medium"
        className={styles.badgeText}
      >
        {score}
      </Text>
    </span>
  );
}

function getStyles(position?: string) {
  return {
    badge: css({
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--background-inverse)",
      borderRadius: "var(--border-radius-2)",
      position: "absolute",
      left: position,
      top: "calc(var(--space-12) + var(--space-2))",
      padding: "var(--space-1) var(--space-2) var(--space-1) var(--space-2)",

      "&::after": {
        content: '""',
        position: "absolute",
        bottom: "100%",
        left: "50%",
        marginLeft: "-5px",
        borderWidth: "5px",
        borderStyle: "solid",
        borderColor:
          "transparent transparent var(--background-inverse) transparent",
      },
    }),
    badgeText: css({
      lineHeight: "var(--font-line-height-5)",
    }),
  };
}
